const $ = window.jQuery

const initAccordion = () => {
  $('.filtermenu-dropdown').accordion({
    header: '.filtermenu-dropdown-title',
    collapsible: true,
    active: false,
    icons: false,
    heightStyle: 'content'
  })
}

const dateStringOptions = {
  year: 'numeric',
  month: 'numeric',
  day: 'numeric'
}

window.initAccordion = initAccordion

export const initializeTrainingFilter = () =>
  $(() => {
    initAccordion()

    $(window).resize(function () {
      window.initAccordion()
    })

    $('.filtermenu').each(function (index, item) {
      const $filter = $(item)
      const $trigger = $filter.find('.filtermenu-trigger')

      $trigger.click(function () {
        $filter.toggleClass('filtermenu--active')
      })
    })

    const ua = navigator.userAgent
    const event = ua.match(/iPad/i) ? 'touchstart' : 'click'
    $('html, body').on(event, function (e) {
      if ($(e.target).closest('.filtermenu').length === 0) {
        $('.filtermenu').removeClass('filtermenu--active')
      }
    })

    $("select[name='region']").change(function () {
      const select = $(this)
      $('.region, .country').hide()
      $('#region' + select.val()).show()

      $("select[name='country']").val('')
      $("select[name='state']").val('')
      $('#filters option').trigger('chosen:updated')
    })

    $("select[name='country']").change(function () {
      const select = $(this)
      $('.country').hide()
      $('#country' + select.val()).show()

      $("select[name='state']").val('')
      $('#filters option').trigger('chosen:updated')
    })

    $('.filtermenu-reset').click(() => {
      window.location = window.location.href.split('?')[0]
      // $("select[name='region']").val('')
      // $("select[name='country']").val('')
      // $("select[name='state']").val('')
      // $('[name="languages[]"]').prop('checked', false)
      // $("select[name='trainingProvider']").val('')
      // $("select[name='eventType']").val('')
      // $("input[name='dateFrom']").val('')
      // $("input[name='dateTo']").val('')
      // $('.region, .country').hide()

      // $('#filters option').trigger('chosen:updated')

      // updateResults()

      return false
    })

    $('#filters input, #filters select').change(function () {
      updateResults()
    })

    function updateResults() {
      const data = $('#filters')
        .serialize()
        .replace(/country=&/g, '')

      if (
        $("select[name='region']").val() ||
        $("select[name='country']").val() ||
        $("select[name='state']").val() ||
        $('[name="languages[]"]').is(':checked') ||
        $("select[name='trainingProvider']").val() ||
        $("select[name='eventType']").val() ||
        $("input[name='dateFrom']").val() ||
        $("input[name='dateTo']").val()
      ) {
        $('.filtermenu-reset').show()
      } else {
        $('.filtermenu-reset').hide()
      }

      const filtersUrl = $('#filters').data('url') || '/umbraco/surface/Website/Courses'

      $.ajax(filtersUrl, {
        data: data,
        method: 'GET',
        dataType: 'json'
      }).done(function (data) {
        $('#filter-results').empty()
        const templateHtml = $('#inClassTrainingHtmlTemplate').html()

        $.each(data.courses, function (i, value) {
          const template = $(templateHtml)

          template.find('.eventitem-image img').attr('src', value.image)
          template.find('.location-text').html(value.locationText)
          template.find('.eventitem-title').text(value.name)

          template.find('.start-end-date').text(value.dateText)

          if (value.languages) {
            template.find('.eventitem-languages').text(value.languages)
          }

          template.find('a').attr('href', value.url)

          if (value.trainingType) {
            template.find('.eventitem-training-type').text(value.trainingType)
          }

          if (value.hideSeatCount) {
            template.find('.available-seats').remove()
          } else {
            template.find('.available-seats').text(value.availableSeatsText)
          }

          if (value.typeColor === 'green') {
            template
              .find('.eventitem-image--label')
              .addClass('eventitem-image--label-green')
              .text(value.typeText)
              .show()
          } else if (value.typeColor === 'blue') {
            template.find('.eventitem-image--label').addClass('eventitem-image--label-blue').text(value.typeText).show()
          } else {
            template.find('.eventitem-image--label').hide()
          }

          if (value.availableSeats > 0 && value.availableSeats <= 3) {
            template.find('.available-seats').addClass('eventitem-highlight')
          }

          $('#filter-results').append(template)
        })
      })
    }
  })
